import React from "react";
import { Modal } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { withRouter } from "react-router-dom";
import cookie from "react-cookies";

import { getLoggedProfile, genOtp, verifyOtp, doActionAfterOptSuccess } from "../../model/profile";

import { commonErr } from "../common/errors";
import { LoadingInline } from "../common/loading";
import { otpAction, otpMethod, OtpBy } from "../common/common";

import { IcOtpCall, IcOtpMessage, Success, Fail } from "../common/svg";

/* Use for both 2 cases: 
    + Active phone number (default)
    { In this case: (gen-otp, verify-otp, do-action), all in this component }
    + Recover password (this.props.action === otpAction.TOA_RECOVER_PASSWORD)
    { In this case: (gen-otp, verify-otp) in this component, after that, pass data to another, to use (do-action) in that}
*/
class VerifyPhoneOpt extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loadedPhoneNumber: false,
			err: commonErr.INNIT,
			errMsg: "",
			step: 0,
			otp: "",
			otpBy: OtpBy.DEFAULT,
		};
	}

	componentDidMount() {
		if (!this.props.phoneNumber) {
			getLoggedProfile().then((loggedProfileResp) => {
				this.setState({
					phoneNumber: loggedProfileResp.data.data.profile.phoneNumber,
				});
			});
		}
	}

	onFocus = () => {
		this.setState({
			wrongVerify: false,
		});
	};

	onOtpChange = (event) => {
		this.setState({
			otp: event,
		});
	};

	handleKeyPress = (event) => {
		if (event.key === "Enter") {
			this.onVerify();
		}
	};

	onVerify = () => {
		const phoneNumber = this.props.phoneNumber || this.state.phoneNumber;
		const action = this.props.action || otpAction.TOA_VERIFY;
		const { verifyToken, attemptTimes, otp, otpBy } = this.state;

		// send api
		verifyOtp(phoneNumber, action, verifyToken, otp, otpBy).then((verifyOtpResp) => {
			if (verifyOtpResp.data.error === commonErr.SUCCESS) {
				const { actionToken } = verifyOtpResp.data.data;
				if (action === otpAction.TOA_VERIFY || action == otpAction.TOA_VERIFY_LOGIN) {
					doActionAfterOptSuccess(
						phoneNumber,
						action,
						otpMethod.TOP_MIOTO,
						verifyToken,
						actionToken,
						otp,
						this.props.pwd
					).then((doActionAfterOptSuccessResp) => {
						if (doActionAfterOptSuccessResp.data.error === commonErr.SUCCESS) {
							this.setState({
								err: commonErr.SUCCESS,
								step: 2,
							});
						} else {
							this.setState({
								err: doActionAfterOptSuccessResp.data.error,
								errMsg: doActionAfterOptSuccessResp.data.errorMessage,
							});
						}
					});
				} else {
					this.setState({
						err: commonErr.SUCCESS,
						step: 2,
						actionToken,
					});
				}
			} else if (attemptTimes - 1 > 0) {
				this.setState({
					wrongVerify: true,
					attemptTimes: attemptTimes - 1,
				});
			} else {
				this.setState({
					step: 2,
				});
			}
		});
	};

	onAccept = (otpBy) => {
		const phoneNumber = this.props.phoneNumber || this.state.phoneNumber;
		const action = this.props.action || otpAction.TOA_VERIFY;

		// send api
		genOtp(phoneNumber, action, otpBy).then((genOtpResp) => {
			if (genOtpResp.data.error === commonErr.SUCCESS) {
				this.setState({
					verifyToken: genOtpResp.data.data.verifyToken,
					step: 1,
					attemptTimes: 3,
					wrongVerify: false,
					otpBy: genOtpResp.data.data.otpBy,
					retryOtpBy: genOtpResp.data.data.retryOtpBy,
				});
				let timeRemain = genOtpResp.data.data.timeResend;
				this.setState({
					countdown: timeRemain + "s",
				});
				// Update the count down every 1 second
				var x = setInterval(() => {
					timeRemain--;
					this.setState({
						countdown: timeRemain + "s",
					});
					if (timeRemain < 0) {
						clearInterval(x);
						this.setState({
							countdown: "",
						});
					}
				}, 1000);
			} else {
				this.setState({
					err: genOtpResp.data.error,
					errMsg: genOtpResp.data.errorMessage,
				});
			}
		});
	};

	finish = () => {
		const phoneNumber = this.props.phoneNumber || this.state.phoneNumber;
		const { verifyToken, actionToken, otp, step } = this.state;

		this.closeForm();
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
			step: 0,
		});

		const pathOTP = cookie.load("_mpathOTP");

		if (step === 2 && this.state.err === commonErr.SUCCESS) {
			if (this.props.action === otpAction.TOA_RECOVER_PASSWORD) {
				this.props.onVerifyPhoneOptSuccess({ resetPwPhone: phoneNumber, verifyToken, actionToken, otp });
			} else if (this.props.action === otpAction.TOA_VERIFY_LOGIN) {
				if (this.props.url && this.props.url != "") {
					this.closeForm();

					window.location.href = this.props.url;
				}
				this.props.getLoggedProfile();
				if (pathOTP) {
					this.props.history.push(pathOTP);
					cookie.remove("_mpathOTP");
				} else {
					window.location.reload();
				}
			} else if (this.props.action === otpAction.TOA_VERIFY) {
				this.props.getProfile();
				if (pathOTP) {
					this.props.history.push(pathOTP);
					cookie.remove("_mpathOTP");
				} else {
					window.location.reload();
				}
			}
		} else if (step === 1) {
			this.props.onBreakVerifyPhoneOtp();
		}

		if (this.props.action === otpAction.TOA_RECOVER_PASSWORD) {
			if (step === 2 && this.state.err === commonErr.SUCCESS) {
				this.props.onVerifyPhoneOptSuccess({ resetPwPhone: phoneNumber, verifyToken, actionToken, otp });
			}
		}
	};

	isValidVerify = () => {
		const { otp, otpBy } = this.state;
		if (otpBy === OtpBy.CALL && otp !== "" && otp.length === 4) {
			return true;
		}
		if (otpBy === OtpBy.MESSAGE && otp !== "" && otp.length === 6) {
			return true;
		}
		return false;
	};

	closeForm = () => {
		this.props.hideModal();
	};

	render() {
		const { step, err, errMsg, otp, wrongVerify, countdown, attemptTimes, otpBy, retryOtpBy } = this.state;
		const phoneNumber = this.props.phoneNumber || this.state.phoneNumber;

		var content;
		if (!phoneNumber) {
			content = <LoadingInline />;
		} else if (err < commonErr.SUCCESS) {
			content = (
				<div className="modal-confirm-body confirm-inner">
					<div className="wrap-svg">
						<Fail />
					</div>
					<p className="textAlign-center">{errMsg}</p>
				</div>
			);
		} else if (step === 2) {
			if (err === commonErr.SUCCESS) {
				content = (
					<div className="modal-confirm-body confirm-inner">
						<div className="wrap-svg">
							<Success />
						</div>
						<h6>
							Xác minh của bạn <br />
							thành công
						</h6>
						<div className="wrap-btn">
							<a className="btn btn-primary btn--m" type="button" onClick={this.finish}>
								{this.props.action === otpAction.TOA_RECOVER_PASSWORD ? "Tiếp tục" : "Hoàn tất"}
							</a>
						</div>
					</div>
				);
			} else {
				content = (
					<div className="modal-confirm-body otp-body">
						<p className="font-14 send-otp">
							Bạn đã nhập sai quá số lần quy định. Bạn có muốn liên hệ với Mioto để được hỗ trợ?
						</p>
						<div className="wrap-btn db-btn">
							<a className="btn btn--s btn-secondary" href="tel:19009217">
								<span>Gọi</span>
							</a>
							<a className="btn btn--s btn-primary" target="_blank" href="https://www.messenger.com/t/mioto.vn">
								<span>Nhắn tin</span>
							</a>
						</div>
					</div>
				);
			}
		} else if (step === 1) {
			content = (
				<div className="modal-confirm-body otp-body">
					<p className="font-14">
						{otpBy === OtpBy.DEFAULT || otpBy === OtpBy.MESSAGE
							? "Nhập 6 chữ số OTP được gửi đến số điện thoại"
							: "Nhập 4 chữ số OTP được gửi đến số điện thoại"}
						<span>“{phoneNumber.replace("+84", "0")}” </span>
					</p>

					{otpBy === OtpBy.DEFAULT || otpBy === OtpBy.MESSAGE ? (
						<div className="otp-block">
							<OtpInput
								inputType="number"
								value={otp}
								onChange={this.onOtpChange}
								numInputs={6}
								renderSeparator={<span> </span>}
								containerStyle={{ gap: "5px" }}
								renderInput={(props) => <input {...props} />}
							/>
						</div>
					) : (
						<div className="otp-block">
							<OtpInput
								inputType="number"
								value={otp}
								onChange={this.onOtpChange}
								numInputs={4}
								renderSeparator={<span> </span>}
								containerStyle={{ gap: "5px" }}
								renderInput={(props) => <input {...props} />}
							/>
						</div>
					)}

					{/* <div className="space m" /> */}

					{/* <div className="form-default">
                    <div className="line-form">
                        <div className="wrap-input" >
                            <input type="text" placeholder="" onFocus={this.onFocus} value={otp} onChange={this.onOtpChange} onKeyPress={this.handleKeyPress} style={{ textAlign: "center" }} autoFocus={true} />
                        </div>
                    </div>
                </div> */}

					{wrongVerify && <p className="text-danger font-14">Mã nhập không đúng. Bạn còn {attemptTimes} lần thử</p>}
					<div>
						<p className="font-14 send-otp">Bạn chưa nhận được mã?</p>
						{countdown === "" ? (
							<div className="wrap-btn db-btn marginTop-xs">
								{retryOtpBy === OtpBy.DEFAULT || retryOtpBy === OtpBy.MESSAGE ? (
									<a className="btn btn--s btn-secondary" onClick={() => this.onAccept(OtpBy.MESSAGE)}>
										<div className="wrap-svg">
											<IcOtpMessage />
										</div>
										<span>Gửi tin nhắn</span>
									</a>
								) : (
									<a className="btn btn--s btn-secondary marginTop-xs" onClick={() => this.onAccept(OtpBy.CALL)}>
										<div className="wrap-svg">
											<IcOtpCall />
										</div>
										<span>Gọi điện thoại</span>
									</a>
								)}
							</div>
						) : (
							<p className="font-14 send-otp">Yêu cầu mã mới trong vòng: {countdown}</p>
						)}
					</div>

					<div className="wrap-btn has-2-btn">
						<a className="btn btn--m btn-primary" onClick={this.onVerify} disabled={otp === "" || otp.length < 4}>
							Xác thực
						</a>
					</div>
				</div>
			);
		} else {
			content = (
				<div className="modal-confirm-body">
					<p className="font-14">
						Hệ thống sẽ gửi tin nhắn chứa mã xác thực đến <br /> số điện thoại của bạn:{" "}
						<strong>{phoneNumber.replace("+84", "0")}</strong>
					</p>
					<div className="wrap-btn has-2-btn">
						<a className="btn btn--m btn-primary" onClick={() => this.onAccept(OtpBy.DEFAULT)}>
							Tiếp tục
						</a>
					</div>
				</div>
			);
			// <div className="textAlign-center">
			//     <img src={opt} />
			// </div>
			// <div className="space m" />

			// <p className="textAlign-center strong">Hệ thống sẽ gửi tin nhắn chứa mã xác thực đến số điện thoại của bạn:</p>
			// <p className="textAlign-center">"{phoneNumber.replace("+84", "0")}"</p>
			// <div className="space m" />
			// <div className="textAlign-center"><a className="btn btn-primary btn--m" type="button" onClick={() => this.onAccept(OtpBy.DEFAULT)}>Tiếp tục</a></div>
		}
		return (
			<Modal show={this.props.show} onHide={this.finish} dialogClassName="modal-s modal-dialog modal-confirm">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Xác thực số điện thoại</h5>
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}

export default withRouter(VerifyPhoneOpt);
